import { useCallback } from 'react';
import { appEvents, APP_EVENTS } from '../services/appEvents';

export const useNotifyDataChange = () => {
  const notifyDataChanged = useCallback((source, details = {}) => {
    console.log(`Уведомление об изменении данных от ${source}:`, details);
    appEvents.emit(APP_EVENTS.DATA_CHANGED, {
      source,
      ...details,
      timestamp: new Date().toISOString()
    });
  }, []);

  const notifyTrainingCompleted = useCallback((trainingData) => {
    appEvents.emit(APP_EVENTS.TRAINING_COMPLETED, trainingData);
    appEvents.emit(APP_EVENTS.DATA_CHANGED, { 
      source: 'trainingCompleted',
      ...trainingData 
    });
  }, []);

  const notifyEnrollmentCreated = useCallback((enrollmentData) => {
    appEvents.emit(APP_EVENTS.ENROLLMENT_CREATED, enrollmentData);
    appEvents.emit(APP_EVENTS.DATA_CHANGED, { 
      source: 'enrollmentCreated',
      ...enrollmentData 
    });
  }, []);

  const notifyCacheInvalidated = useCallback((cacheName) => {
    appEvents.emit(APP_EVENTS.CACHE_INVALIDATED, { cacheName });
    appEvents.emit(APP_EVENTS.DATA_CHANGED, { 
      source: 'cacheInvalidated',
      cacheName 
    });
  }, []);

  return {
    notifyDataChanged,
    notifyTrainingCompleted,
    notifyEnrollmentCreated,
    notifyCacheInvalidated
  };
};